import { INITIALIZE_VALUES } from '../actionTypes';
import { createProposalModalActions } from '../reducer';

export default (values) =>
    createProposalModalActions[INITIALIZE_VALUES](values);
